module.exports = __webpack_public_path__ + "static/media/hanukkah-small.ceccd38a.gif";